import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { SubmitLiquidationDocuments } from 'features/Project/pages';
import { Mode } from 'constant';

function LiquidationDocumentEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <SubmitLiquidationDocuments mode={Mode.EDIT} />
      </Layout>
    </LayoutProvider>
  );
}

export default LiquidationDocumentEditPage;
